// Additional fix for browser back navigation
$(window).on('pageshow', function(event) {
  if ($('#personalizeYes').is(':checked')) {
    $('.product_custom-options').css('display', 'block');
    $('.txt_link_show').css('display', 'block');
  } else {
    $('.product_custom-options').css('display', 'none');
    $('.txt_link_show').css('display', 'none');
  }
});
document.addEventListener("DOMContentLoaded", () => {

   // Select the "here" link dynamically
    const linkElement = document.querySelector('#txt_personalize a[title="#"]');
    const modal = document.querySelector('#personalizeModal'); // Modal element
    const closeModalButton = modal.querySelector('.close-button'); // Close button
    const swiperContainer = document.querySelector("#popup-swiper");
    // Initialize Swiper
    const swiper = new Swiper(swiperContainer, {
      loop: true,
      slidesPerView: 2, // Display 2 slides at a time
      slidesPerGroup: 2, // Move 2 slides at a time
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

  
  // Open modal on link click
  linkElement.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default link behavior
      modal.style.display = 'block'; // Show modal
    // Trigger Swiper update after modal is visible
    setTimeout(() => {
      swiper.update();
    }, 100); // Slight delay to ensure the modal is fully visible
    });
  
  // Close modal on close button click
  closeModalButton.addEventListener('click', function () {
      modal.style.display = 'none'; // Hide modal
  });


 
  const radioGroups = document.querySelectorAll('[data-option-name="Backstiching"]'); // Target all relevant groups

  radioGroups.forEach(group => {
    const yesButton = group.querySelector('label[for="ProductOption-backstiching-product_custom_option_af3bUN-2"]');
    const noButton = group.querySelector('label[for="ProductOption-backstiching-product_custom_option_af3bUN-1"]');
    const link = group.querySelector('#backstitchingLink'); // Link to show/hide
    const modal = group.querySelector('#backstitchingModal'); // Modal to open/close
  const backstich_swiper = group.querySelector('.backstich_swiper'); // Modal to open/close
    
    const openModalLink = group.querySelector('#openModal');
    const closeModal = modal ? modal.querySelector('.close-button') : null;
    const overlay = group.querySelector('.modal-popup-overlay');

      const swiperContainer1 = document.querySelector("#backstich_swiper");
    let swiperInstance = null;
      

 
    // Show link when "Yes" is clicked
    yesButton.addEventListener('click', () => {
      link.style.display = 'block'; // Show link
    });

    // Hide link when "No" is clicked
    noButton.addEventListener('click', () => {
      link.style.display = 'none'; // Hide link
    });
if (backstich_swiper) {
        swiperInstances = new Swiper(backstich_swiper, {
          loop: true,
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        // Update Swiper after the modal is fully visible
        setTimeout(() => {
//console.log("swiperContainer1", swiperContainer1);
          swiperInstances.update();
        }, 100);
      }
openModalLink.addEventListener('click', (event) => {
      event.preventDefault();
      modal.style.display = 'block'; // Show modal

      // Initialize Swiper only if it's not already initialized
      
    });

    // Close modal when close button is clicked
    closeModal.addEventListener('click', () => {
      modal.style.display = 'none'; // Hide modal
      overlay.style.display = 'none'; // Hide overlay
    });

    // Close modal if clicking outside modal content
    window.addEventListener('click', (event) => {
      if (event.target === overlay) {
        modal.style.display = 'none'; // Hide modal
        overlay.style.display = 'none'; // Hide overlay
      }
    });
  });


  
  // Select all radio buttons for font options
  const fontRadios = document.querySelectorAll('input[name="properties[Fonts]"]');
  
  // The input field where the font-family will be applied
  const targetInput = document.querySelector('#ProductOption-text-product_custom_option_dUaPdL');
  
  // Function to update font styles dynamically based on the selected radio button
  function updateFontStyles() {
    // Get the selected font name from the radio button
    const selectedFont = document.querySelector('input[name="properties[Fonts]"]:checked').value.trim();

    // Apply the font-family to the target input field
    if (targetInput) {
      targetInput.style.fontFamily = `"${selectedFont}", sans-serif`;
    }

    // Optionally, display the selected font dynamically in an element
    const selectedFontDisplay = document.querySelector('#selected-font-display');
    if (selectedFontDisplay) {
      selectedFontDisplay.innerText = `Selected Font: ${selectedFont}`;
    }

    // Update the placeholder dynamically (optional)
    if (targetInput) {
      targetInput.placeholder = `Enter text in ${selectedFont}`;
    }
  }

  // Function to apply font styles to radio button labels
  function applyFontStylesToRadios() {
    fontRadios.forEach(radio => {
      const fontName = radio.value.trim(); // Get the font name from each radio button's value
      const label = radio.closest('.single-option-selector__wrap-option')
                         .querySelector('.single-option-selector__option__text'); // Find the label text
      
      if (label) {
        label.style.fontFamily = `"${fontName}", sans-serif`; // Apply the font family to the label
      }
    });
  }

  // Event listener for each radio button to update the font when selected
  fontRadios.forEach(radio => {
    radio.addEventListener("change", updateFontStyles);
  });

  // Run the functions on page load to set initial fonts
  updateFontStyles();        
  applyFontStylesToRadios();  // Apply font family to radio button labels

  
});

document.addEventListener("DOMContentLoaded", function () {
  $('.txt_link_show').css('display', 'none');
  const personalizeRadioYes = document.querySelector("#personalizeYes"); // 'Yes' radio button
  const personalizeRadioNo = document.querySelector("#personalizeNo"); // 'No' radio button
  const fieldsToValidate = document.querySelectorAll(".validate-field"); // Fields that need to be validated
  const addToCartButton = document.querySelector("#add-to-cart-button"); // Add to Cart button
  const productCustomOptions = document.querySelector(".product_custom-options"); // Custom options container

  // Toggle the visibility of custom options based on the radio button selection
  $('input[name="personalize"]').change(function () {
   
    if ($('#personalizeYes').is(':checked')) {
      // Show the custom options if 'Yes' is selected
      $('.product_custom-options').css('display', 'block');
       $('.txt_link_show').css('display', 'block');
      console.log("Show the custom options if 'Yes' is selected");
    } else {
      // Hide the custom options if 'No' is selected
      $('.product_custom-options').css('display', 'none');
      $('.txt_link_show').css('display', 'none');
      console.log("Hide the custom options if 'No' is selected");
    }
  });

  addToCartButton.addEventListener("click", function (event) {
    // Validate only if the 'Yes' radio button is selected
    if (personalizeRadioYes.checked) {
      let isValid = true; // Flag to track validation

      // Loop through each field and validate
      fieldsToValidate.forEach(field => {
        const fieldContainer = field.closest(".field");

        // Remove previous error state
        if (fieldContainer) {
          fieldContainer.classList.remove("abc");
          const error = fieldContainer.querySelector(".error-message");
          if (error) error.remove();
        }

        // Validation logic
        if (field.type === "radio" || field.type === "checkbox") {
          const groupName = field.name;
          const group = document.querySelectorAll(`[name="${groupName}"]`);
          const isGroupChecked = Array.from(group).some(input => input.checked);

          if (!isGroupChecked) {
            isValid = false;
            if (fieldContainer) {
              fieldContainer.classList.add("abc");
              if (!fieldContainer.querySelector(".error-message")) {
                const error = document.createElement("span");
                error.textContent = "Please select an option.";
                error.classList.add("error-message");
                fieldContainer.appendChild(error);
              }
            }
          }
        } else if (field.type === "text" && field.value.trim() === "") {
          isValid = false;
          if (fieldContainer) {
            fieldContainer.classList.add("abc");
            if (!fieldContainer.querySelector(".error-message")) {
              const error = document.createElement("span");
              error.textContent = "This field is required.";
              error.classList.add("error-message");
              fieldContainer.appendChild(error);
            }
          }
        }
      });

      // If validation fails, prevent form submission and scroll to the first invalid field
      if (!isValid) {
        event.preventDefault();
        document.querySelector(".abc").scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  });
});

